export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            employeeTypes: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        employeeTypes(state) {
            return state.employeeTypes.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setEmployeeType(state, employeeTypes) {
            state.employeeTypes = employeeTypes
        },
    },

    actions: {
        async getEmployeeTypes(context) {
            context.commit('setLoading', true);
        
            await axios.get(`${this.state.host}/get-employee-types`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setEmployeeType', res.data.employeeTypes);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveEmployeeType(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-employee-type';
            } else {
                url = 'add-employee-type';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getEmployeeTypes');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteEmployeeType(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-employee-type/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getEmployeeTypes');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}
